"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormSubmissionNotFound = void 0;
class FormSubmissionNotFound extends Error {
    constructor(submissionId) {
        super(`Form submission not found for ID: ${submissionId}`);
    }
}
exports.FormSubmissionNotFound = FormSubmissionNotFound;
//# sourceMappingURL=FormSubmissionNotFound.js.map